import { UliActivityType } from '../../../../../../common/constants/uli';

export class AllocationViewLeadUliModel {
  uli: string;
  activityTpe: UliActivityType;
  compartmentId: number;

  constructor(params?: AllocationViewLeadUliModel) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export function isLeadUli(
  leadUlis: AllocationViewLeadUliModel[],
  uli: string,
  activityType: UliActivityType,
  compartmentId: number,
): boolean {
  if (!leadUlis || !uli || !activityType) {
    return false;
  }
  return leadUlis.some(
    (leadUli: AllocationViewLeadUliModel) =>
      leadUli.uli === uli && leadUli.activityTpe === activityType && leadUli.compartmentId === compartmentId,
  );
}
